import { useBlocNext } from "@blac/react";
import { FC, useEffect } from "react";
import { AnimatedSwitch, Match } from "@9amhealth/shared";
import MedicalInsuranceCardDetailsForm from "./MedicalInsuranceCardDetailsForm";
import MedicalInsuranceFormBloc, {
  AddMedicalInsuranceInfoAction
} from "./MedicalInsuranceFormBloc";
import MedicalInsuranceSelectHealthPlanForm from "./MedicalInsuranceSelectHealthPlanForm";
import MedicalInsuranceUploadPhoto from "./MedicalInsuranceUploadPhoto";
import MedicalInsuranceSubscriberInformationForm from "components/MedicalInsuranceForm/MedicalInsuranceSubscriberInformationForm";
import { TaskConfigAdditionalData } from "../TaskList/TaskListBloc";
import styled from "@emotion/styled";
import { APP_CONTENT_WIDTH } from "src/constants/layout";

const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: min(100%, ${APP_CONTENT_WIDTH}px);
  margin: 0 auto;
  padding: 2rem 1.6rem;
`;

const MedicalInsuranceForm: FC<{
  onStepChange: () => void;
  taskAdditionalData?: TaskConfigAdditionalData;
  onSaved?: () => void;
  closePopupOnSave?: boolean;
}> = (props) => {
  const [
    { step },
    { setInitialStep, setPhotoUploadCanBeSkippedByUser, setOnSaved }
  ] = useBlocNext(MedicalInsuranceFormBloc, {
    id: "medical-insurance-form"
  });

  useEffect(() => {
    setPhotoUploadCanBeSkippedByUser(
      props.taskAdditionalData?.photoUploadCanBeSkippedByUser ?? false
    );
  }, [props.taskAdditionalData]);

  useEffect(() => {
    setOnSaved(props.onSaved, props.closePopupOnSave ?? true);
  }, [props.onSaved, props.closePopupOnSave]);

  useEffect(() => {
    props.onStepChange();
  }, [step]);

  useEffect(() => {
    setInitialStep();
  }, []);

  return (
    <AnimatedSwitch value={step} fillHeight>
      <Match case={AddMedicalInsuranceInfoAction.SELECT_HEALTH_PLAN}>
        <CenterContent>
          <MedicalInsuranceSelectHealthPlanForm />
        </CenterContent>
      </Match>
      <Match case={AddMedicalInsuranceInfoAction.ADD_CARD_DETAILS}>
        <CenterContent>
          <MedicalInsuranceCardDetailsForm />
        </CenterContent>
      </Match>
      <Match case={AddMedicalInsuranceInfoAction.SUBSCRIBER_INFO}>
        <CenterContent>
          <MedicalInsuranceSubscriberInformationForm />
        </CenterContent>
      </Match>
      <Match case={AddMedicalInsuranceInfoAction.ADD_CARD_PHOTOS}>
        <CenterContent>
          <MedicalInsuranceUploadPhoto />
        </CenterContent>
      </Match>
    </AnimatedSwitch>
  );
};

export default MedicalInsuranceForm;
